import { compose } from "recompose";

import cartCouponCodeRemove, {
  ICartCouponCodeRemoveProps,
} from "../../../../hoc/persister/cartCouponCodeRemove/cartCouponCodeRemove";
import cartGiftCardRemove, {
  ICartGiftCardRemoveProps,
} from "../../../../hoc/persister/cartGiftCardRemove/cartGiftCardRemove";
import cartUpdate from "../../../../hoc/persister/cartUpdate";
import { ICartUpdateProps } from "../../../../hoc/persister/cartUpdate/cartUpdate";

import PriceRecap, { IProps } from "./PriceRecap.component";

type IConnectedProps = ICartUpdateProps &
  ICartCouponCodeRemoveProps &
  ICartGiftCardRemoveProps;

type IContainerProps = Omit<IProps, keyof IConnectedProps>;

export default compose<IProps, IContainerProps>(
  cartUpdate,
  cartGiftCardRemove,
  cartCouponCodeRemove
)(PriceRecap);
